import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { NgxSpinnerService } from "ngx-spinner";
import { HistoricoEscolar } from "src/app/models/historicoEscolar";
import { BuscaService } from "src/app/services/busca.service";

@Component({
  selector: "busca",
  templateUrl: "./busca.component.html",
  styleUrls: ["./busca.component.scss"],
  standalone: false,
})
export class BuscaComponent implements OnInit {
  @ViewChild("Resultado") resultado: ElementRef;

  @Input() ies: any;

  buscaForm: UntypedFormGroup;
  captcha = "";
  resultadoBusca: HistoricoEscolar = null;

  xmlDownloadLink: SafeResourceUrl;
  xmlFile: string;
  naoEncontrado = false;

  nomeArquivo = `historico_escolar_${new Date().getDate() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getFullYear()}.xml`;

  constructor(
    private _formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService,
    private _busca: BuscaService,
    private domSanitizer: DomSanitizer
  ) {
    this.buscaForm = this._formBuilder.group({
      Codigo: ["", Validators.required],
      Captcha: ["", Validators.required],
      //Captcha: [''] // debug
    });
  }

  ngOnInit(): void {
    this.generateCaptcha();
  }

  generateCaptcha() {
    let a = "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
      n = "0123456789",
      cap_size = 4, // Captcha length
      captchaTemp = "";

    while (cap_size--) {
      if (this.rand(2) === 0) {
        // if 0 add a random alphabetic character
        captchaTemp += a[this.rand(a.length)];
      } else {
        // if 1 add a random numeric character
        captchaTemp += n[this.rand(n.length)];
      }
    }

    this.captcha = captchaTemp;
  }

  rand(x: number) {
    return Math.floor(Math.random() * x);
  }

  buscar() {
    this.spinner.show();

    this._busca
      .getHistorico("", this.buscaForm.controls["Codigo"].value)
      .subscribe(
        (response) => {
          this.resultadoBusca = response[0];

          // Link para download do arquivo XML
          this.xmlDownloadLink =
            this.domSanitizer.bypassSecurityTrustResourceUrl(
              "data:application/octet-stream;base64," +
              this.resultadoBusca.codXMLPublico
            );

          // Printa o XML na tela
          this.xmlFile = atob(this.resultadoBusca.codXMLPublico);

          // Scroll para resultado
          setTimeout(() => {
            window.scroll({
              top: this.resultado.nativeElement.offsetTop - 80,
              behavior: "smooth",
            });
          }, 250);

          // Esconde o loader
          this.spinner.hide();
        },
        (error) => {
          // Esconde o loader
          this.spinner.hide();
          this.naoEncontrado = true;

          if (error.status === 404) {
            this.resultadoBusca = null;
          } else {
            console.log(error);
          }
        }
      );
  }

  formataCPF(cpf) {
    return ("0" + cpf).slice(-11);
  }
}
